import { Translate } from './LanguageService';
import vitecExpressHelpImage from '../assets/images/broker-system-connection-help/vitec-express-help-objectId.png';

export interface IContentProvider {
    id: number;
    name: string;
    manualConnectionHelperImage?: string;
    canManuallyConnect?: boolean;
    tenants?: string[];
}

export enum ContentProviderId {
    Unknown = 0,
    VitecExpress = 1,
    Mspecs = 2,
    VitecMaklarsystem = 3,
    Fasad = 4,
    VitecSaljstod = 5,
    FasIt = 6,
    Linear = 7,
}

const hasPathLikeCharactersOrEncodedNewLine = (value: string): boolean => (
    value.includes('/')
    || value.includes('\\')
    || value.includes('%2F')
    || value.includes('%5C')
    || value.includes('%0A')
    || value.includes('%0D')
);

const objectIdValidationByProvider: Partial<Record<ContentProviderId, (objectId: string) => boolean>> = {
    [ContentProviderId.VitecExpress]: hasPathLikeCharactersOrEncodedNewLine,
};

export const ContentProviders: IContentProvider[] = [
    { id: ContentProviderId.Unknown, name: 'contentprovider/unknown', canManuallyConnect: false, tenants: ['se360', 'zentuvo'] },
    { id: ContentProviderId.VitecExpress, name: 'contentprovider/vitecexpress', manualConnectionHelperImage: vitecExpressHelpImage, canManuallyConnect: true, tenants: ['se360']},
    { id: ContentProviderId.Mspecs, name: 'contentprovider/mspecs', canManuallyConnect: false, tenants: ['se360'] },
    { id: ContentProviderId.VitecMaklarsystem, name: 'contentprovider/vitecmaklarsystem', canManuallyConnect: false, tenants: ['se360'] },
    { id: ContentProviderId.Fasad, name: 'contentprovider/fasad', canManuallyConnect: false, tenants: ['se360'] },
    { id: ContentProviderId.VitecSaljstod, name: 'contentprovider/vitecsaljstod', canManuallyConnect: false, tenants: ['se360'] },
    { id: ContentProviderId.FasIt, name: 'contentprovider/fasit', canManuallyConnect: false, tenants: ['se360'] },
    { id: ContentProviderId.Linear, name: 'contentprovider/linear', canManuallyConnect: false, tenants: ['zentuvo'] }
];

export const hasInvalidObjectIdFormatForContentProvider = (
    contentProviderId: number | null | undefined,
    objectId: string,
): boolean => {
    if (contentProviderId == null) {
        return false;
    }

    const validator = objectIdValidationByProvider[contentProviderId as ContentProviderId];

    if (!validator) {
        return false;
    }

    return validator(objectId.trim());
};

export const getContentProviderNameFromId = (id: number) => {
    const provider = ContentProviders.find((m) => m.id === id);

    if (!provider) {
        return '';
    }

    return Translate(provider.name);
};

export const getSupportedContentProvidersForManualConnection = (): IContentProvider[] => {
    const site = window.appConfig.site;
    return ContentProviders.filter(
        p => p.tenants && p.tenants.indexOf(site) !== -1 && p.canManuallyConnect
    );
};

export const getBrokerSystemHelpContent = (contentProviderId: number): string | null => {
    const provider = ContentProviders.find((p) => p.id === contentProviderId);
    return provider && provider.manualConnectionHelperImage ? provider.manualConnectionHelperImage : null;
};
